module.exports = __webpack_public_path__ + "e034bd915f73c61a0e4c7ca14fe1683f.svg";